// extracted by mini-css-extract-plugin
export default {"root":"g_hyiSkQ0m3b8mJhuSZm","wrapper":"CLMCso70mdNkRle02JJP"};